var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDollarShield(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M20 11.182c0 4.541-3.413 8.787-8 9.818-4.587-1.031-8-5.277-8-9.818V7.243a2 2 0 011.243-1.851l5-2.046a4.637 4.637 0 013.514 0l5 2.046A2 2 0 0120 7.243v3.939zM12 8.5v-1M12 14.5v1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M10.264 13.785c.259.424.701.717 1.236.717h1.096a1.404 1.404 0 00.341-2.767l-1.875-.471a1.404 1.404 0 01.342-2.765H12.5c.533 0 .975.292 1.233.715"
  }))));
}
export default SvgDollarShield;


//////////////////
// WEBPACK FOOTER
// ./src/icons/dollar-shield.svg
// module id = 747
// module chunks = 13